"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const rose = {
    100: "#4c3731",
    90: "#674840",
    80: "#7b544a",
    70: "#916255",
    60: "#ab7060",
    50: "#c6806c",
    40: "#dd9581",
    30: "#f3ab96",
    20: "#f8c6b9",
    10: "#f7ded7",
    0: "#f8edeb",
};
exports.default = rose;
//# sourceMappingURL=rose.js.map